// extracted by mini-css-extract-plugin
export default {"cloud":"WordCloud_cloud__C7usc","tag":"WordCloud_tag__Ns7iD"};